import { render, staticRenderFns } from "./Busca.vue?vue&type=template&id=5f4905b6&scoped=true&"
import script from "./Busca.vue?vue&type=script&lang=js&"
export * from "./Busca.vue?vue&type=script&lang=js&"
import style0 from "./Busca.vue?vue&type=style&index=0&id=5f4905b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4905b6",
  null
  
)

export default component.exports